
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getIsAfterTime } from '@/utils/util'
import scroll from '@/mixins/scroll'
import SearchNav from '@/views/industryMall/shop/template/SearchNav.vue'
import { addStoreSearchHistory, getGoodsOrStoreCount } from '@/api/industryMall'
import SearchActivityGoodsCard from '@/views/industryMall/shop/template/SearchActivityGoodsCard.vue'
import { ShopGoodsInfoDto, getActivityGoodsList, getActivityDtlGoodsList } from '@/api/industryMall'

@Component({
  name: 'SearchLimitActivity',
  components: { SearchNav, SearchActivityGoodsCard }
})
export default class SearchLimitActivity extends Mixins(scroll) {
  @Getter partnerCompanyId!: string
  @Getter companyId!: string
  params = {
    pageIndex: 1,
    pageSize: 20,
    keyword: '', // 搜索关键字
    activityId: '', // 活动编号
    categoryId: '',
    companyId: '',
    partnerCompanyId: '' // 合作方企业编号
  }
  goodsList: any[] = []
  refreshing = false
  loading = false
  finished = false
  listScrollTop = 0
  isActivated = false
  countInfo = {
    goodsCount: 0,
    storeCount: 0
  }
  showData = {
    isAfterAdvance: false, // 是否过了提前展示时间
    isAfterBegin: false // 是否过了开始时间
  }

  created () {
    getActivityGoodsList({ activityId: this.$route.query.activityId as string }).then(res => {
      // 是否提前展示
      this.showData = getIsAfterTime(res.data[0])
    })
  }

  mounted() {
    this.params.keyword = this.$route.query.keyword as string
    this.params.partnerCompanyId = this.partnerCompanyId
    this.params.activityId = this.$route.query.activityId as string
    this.params.companyId = this.companyId
    this.addStoreSearchHistory()
    this.getGoodsList()
  }

  activated () {
    if (this.isActivated) {
      this.$setScrollY()
    } else {
      this.isActivated = true
    }
  }

  deactivated () {
    this.$removeScrollListener()
  }

  handleScroll (event: any) {
    this.listScrollTop = event.target.scrollTop
  }

  onLoad() {
    this.params.pageIndex++
    this.getGoodsList()
  }

  /**
   * 获取商品列表
   */
  getGoodsList() {
    getActivityDtlGoodsList(this.params)
      .then((res) => {
        if (this.refreshing || this.loading) {
          this.goodsList = []
        }
        this.goodsList = this.goodsList.concat(res.data.records)
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
        if (this.goodsList.length) {
          this.$removeScrollListener()
          this.$nextTick(() => {
            this.$addScrollListener('.goods-refresh')
          })
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.refreshing = false
        this.loading = false
      })
  }

    /**
   * 下拉刷新
   * */
  onRefresh() {
    console.log('onRefresh ***')
    this.params.pageIndex = 1
    this.refreshing = true
    this.getGoodsList()
  }


  // 产业商城搜索历史记录管理（SM）
  addStoreSearchHistory() {
    // console.log('this', this.keyword, this.partnerCompanyId)
    const data = {
      searchType: 3,
      keyword: this.params.keyword,
      storeId: this.partnerCompanyId
    }
    addStoreSearchHistory({ ...data })
    this.getGoodsOrStoreCount()
  }

  searchFunc(keyword: string) {
    this.params.keyword = keyword
    this.addStoreSearchHistory()
    this.onRefresh()
  }

  getGoodsOrStoreCount() {
    getGoodsOrStoreCount({ ...this.params }).then((res) => {
      if (!res.data.storeCount) {
        // this.activeName = 'goodsList'
      } else if (res.data.goodsCount === 0) {
        // this.activeName = 'storeList'
      }
    })
  }
}
